module.exports = __webpack_public_path__ + "static/media/achievement-3-days-caffine-free.90fd9a2b.svg";